module.exports = __webpack_public_path__ + "static/img/img15.e6d8fd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/img15.jpg
// module id = YiBM
// module chunks = 1